<div class="deals-pipeline" (click)="closeAllDropdowns()">
    @let COL_SCHOOL_NAME = 'School Name';
    @let COL_CITY = 'City';
    @let COL_STAGE = 'Stage';
    @let COL_LEAD_AGEING = 'Lead Ageing';
    @let COL_PRODUCT = 'Product';
    @let COL_POTENTIAL_REVENUE = 'Potential Revenue';
    @let COL_LAST_CONTACTED = 'Last Contacted';
    <!-- Header -->
    <div class="deals-pipeline__header">
        <div class="deals-pipeline__title-section">
            <h2 class="deals-pipeline__title">{{ title() }}</h2>
        </div>
        @if (!isLoading() && !error()) {
            <div class="deals-pipeline__header-total">
                <span class="deals-pipeline__total-label">{{
                    valueConstants.TOTAL_PIPELINE_VALUE_LABEL
                }}</span>
                <span class="deals-pipeline__total-value">{{ totalPipelineValue() }}</span>
            </div>
        }
    </div>

    <!-- Filters Row -->
    <div class="deals-pipeline__filters">
        <div class="filter-icon">
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="filter-icon__svg"
            >
                <path
                    d="M2.5 5h15M5 10h10M7.5 15h5"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                />
            </svg>
            <span>{{ valueConstants.FILTERS_LABEL }}</span>
        </div>

        <!-- School Name Search -->
        <div class="filter-search">
            <input
                type="text"
                class="filter-search__input"
                #schoolSearchInput
                [value]="schoolNameSearch()"
                (input)="onSearchChange(schoolSearchInput.value)"
                [placeholder]="valueConstants.SEARCH_SCHOOL_NAME_PLACEHOLDER"
            />
        </div>

        <!-- Stage Filter -->
        <div class="filter-dropdown">
            <button
                class="filter-dropdown__button"
                (click)="toggleDropdown(EDealsPipelineFilterType.STAGE); $event.stopPropagation()"
                [class.filter-dropdown__button--active]="
                    stageFilter() !== valueConstants.ALL_STAGES
                "
                type="button"
            >
                {{ formatStageCode(stageFilter()) }}
                <img
                    src="assets/icons/dropdown-arrow.svg"
                    alt="Dropdown arrow"
                    class="filter-dropdown__icon"
                />
            </button>

            @if (isStageDropdownOpen()) {
                <div class="filter-dropdown__menu" (click)="$event.stopPropagation()">
                    @for (option of stageOptions(); track option.value) {
                        <div
                            class="filter-dropdown__option"
                            [class.filter-dropdown__option--selected]="
                                stageFilter() === option.value
                            "
                            (click)="selectStageFilter(option.value)"
                        >
                            {{ option.label }}
                        </div>
                    }
                </div>
            }
        </div>

        <!-- Product Filter -->
        <div class="filter-dropdown">
            <button
                class="filter-dropdown__button"
                (click)="toggleDropdown(EDealsPipelineFilterType.PRODUCT); $event.stopPropagation()"
                [class.filter-dropdown__button--active]="
                    productFilter() !== valueConstants.ALL_PRODUCTS
                "
                type="button"
            >
                {{ productFilter() }}
                <img
                    src="assets/icons/dropdown-arrow.svg"
                    alt="Dropdown arrow"
                    class="filter-dropdown__icon"
                />
            </button>

            @if (isProductDropdownOpen()) {
                <div class="filter-dropdown__menu" (click)="$event.stopPropagation()">
                    @for (option of productOptions(); track option.value) {
                        <div
                            class="filter-dropdown__option"
                            [class.filter-dropdown__option--selected]="
                                productFilter() === option.value
                            "
                            (click)="selectProductFilter(option.value)"
                        >
                            {{ option.label }}
                        </div>
                    }
                </div>
            }
        </div>

        <!-- City Filter -->
        <div class="filter-dropdown">
            <button
                class="filter-dropdown__button"
                (click)="toggleDropdown(EDealsPipelineFilterType.CITY); $event.stopPropagation()"
                [class.filter-dropdown__button--active]="cityFilter() !== valueConstants.ALL_CITIES"
                type="button"
            >
                {{ cityFilter() }}
                <img
                    src="assets/icons/dropdown-arrow.svg"
                    alt="Dropdown arrow"
                    class="filter-dropdown__icon"
                />
            </button>

            @if (isCityDropdownOpen()) {
                <div class="filter-dropdown__menu" (click)="$event.stopPropagation()">
                    @for (option of cityOptions(); track option.value) {
                        <div
                            class="filter-dropdown__option"
                            [class.filter-dropdown__option--selected]="
                                cityFilter() === option.value
                            "
                            (click)="selectCityFilter(option.value)"
                        >
                            {{ option.label }}
                        </div>
                    }
                </div>
            }
        </div>
    </div>

    <!-- Skeleton Loader -->
    @if (isLoading()) {
        <div class="deals-pipeline__skeleton">
            <div class="deals-table">
                <div class="deals-table__header">
                    <div class="deals-table__header-cell deals-table__header-cell--school">
                        <div class="skeleton-item"></div>
                    </div>
                    <div class="deals-table__header-cell deals-table__header-cell--city">
                        <div class="skeleton-item"></div>
                    </div>
                    <div class="deals-table__header-cell deals-table__header-cell--stage">
                        <div class="skeleton-item"></div>
                    </div>
                    <div class="deals-table__header-cell deals-table__header-cell--ageing">
                        <div class="skeleton-item"></div>
                    </div>
                    <div class="deals-table__header-cell deals-table__header-cell--product">
                        <div class="skeleton-item"></div>
                    </div>
                    <div class="deals-table__header-cell deals-table__header-cell--revenue">
                        <div class="skeleton-item"></div>
                    </div>
                    <div class="deals-table__header-cell deals-table__header-cell--contacted">
                        <div class="skeleton-item"></div>
                    </div>
                </div>
                <div class="deals-table__body">
                    @for (row of dealSkeletonRows; track row) {
                        <div class="deals-table__row">
                            <div class="deals-table__cell deals-table__cell--school">
                                <div class="skeleton-item"></div>
                            </div>
                            <div class="deals-table__cell deals-table__cell--city">
                                <div class="skeleton-item"></div>
                            </div>
                            <div class="deals-table__cell deals-table__cell--stage">
                                <div class="skeleton-item"></div>
                            </div>
                            <div class="deals-table__cell deals-table__cell--ageing">
                                <div class="skeleton-item"></div>
                            </div>
                            <div class="deals-table__cell deals-table__cell--product">
                                <div class="skeleton-item"></div>
                            </div>
                            <div class="deals-table__cell deals-table__cell--revenue">
                                <div class="skeleton-item"></div>
                            </div>
                            <div class="deals-table__cell deals-table__cell--contacted">
                                <div class="skeleton-item"></div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }

    <!-- Table -->
    @if (!isLoading() && !error()) {
        <div class="deals-table">
            <div class="deals-table__header">
                <div
                    class="deals-table__header-cell deals-table__header-cell--school deals-table__header-cell--sortable"
                    (click)="toggleSort('schoolName')"
                >
                    {{ COL_SCHOOL_NAME }}
                    <span
                        class="sort-arrow"
                        [class.sort-arrow--active]="sortColumn() === 'schoolName'"
                        [class.sort-arrow--desc]="
                            sortColumn() === 'schoolName' &&
                            sortDirection() === ETableSortDirection.DESC
                        "
                    ></span>
                </div>
                <div class="deals-table__header-cell deals-table__header-cell--city">
                    {{ COL_CITY }}
                </div>
                <div
                    class="deals-table__header-cell deals-table__header-cell--stage deals-table__header-cell--sortable"
                    (click)="toggleSort('stage')"
                >
                    {{ COL_STAGE }}
                    <span
                        class="sort-arrow"
                        [class.sort-arrow--active]="sortColumn() === 'stage'"
                        [class.sort-arrow--desc]="
                            sortColumn() === 'stage' && sortDirection() === ETableSortDirection.DESC
                        "
                    ></span>
                </div>
                <div
                    class="deals-table__header-cell deals-table__header-cell--ageing deals-table__header-cell--sortable"
                    (click)="toggleSort('leadAgeing')"
                >
                    {{ COL_LEAD_AGEING }}
                    <span
                        class="sort-arrow"
                        [class.sort-arrow--active]="sortColumn() === 'leadAgeing'"
                        [class.sort-arrow--desc]="
                            sortColumn() === 'leadAgeing' &&
                            sortDirection() === ETableSortDirection.DESC
                        "
                    ></span>
                </div>
                <div class="deals-table__header-cell deals-table__header-cell--product">
                    {{ COL_PRODUCT }}
                </div>
                <div
                    class="deals-table__header-cell deals-table__header-cell--revenue deals-table__header-cell--sortable"
                    (click)="toggleSort('potentialRevenue')"
                >
                    {{ COL_POTENTIAL_REVENUE }}
                    <span
                        class="sort-arrow"
                        [class.sort-arrow--active]="sortColumn() === 'potentialRevenue'"
                        [class.sort-arrow--desc]="
                            sortColumn() === 'potentialRevenue' &&
                            sortDirection() === ETableSortDirection.DESC
                        "
                    ></span>
                </div>
                <div
                    class="deals-table__header-cell deals-table__header-cell--contacted deals-table__header-cell--sortable"
                    (click)="toggleSort('lastContacted')"
                >
                    {{ COL_LAST_CONTACTED }}
                    <span
                        class="sort-arrow"
                        [class.sort-arrow--active]="sortColumn() === 'lastContacted'"
                        [class.sort-arrow--desc]="
                            sortColumn() === 'lastContacted' &&
                            sortDirection() === ETableSortDirection.DESC
                        "
                    ></span>
                </div>
            </div>

            <div class="deals-table__body">
                @if (sortedDeals().length) {
                    @for (deal of sortedDeals(); track deal.schoolName + deal.stageId) {
                        <div class="deals-table__row">
                            <div class="deals-table__cell deals-table__cell--school">
                                @if (deal.organisationCode != null) {
                                    <button
                                        z-button
                                        zType="link"
                                        type="button"
                                        class="deals-table__school-name-link"
                                        (click)="navigateToViewClient(deal.organisationCode!)"
                                    >
                                        {{ deal.schoolName }}
                                    </button>
                                } @else {
                                    <span class="deals-table__school-name">{{
                                        deal.schoolName
                                    }}</span>
                                }
                            </div>
                            <div class="deals-table__cell deals-table__cell--city">
                                <span class="deals-table__city-name">{{ deal.city }}</span>
                            </div>
                            <div class="deals-table__cell deals-table__cell--stage">
                                <span class="deals-table__stage-badge">{{
                                    formatStageCode(deal.stageCode)
                                }}</span>
                            </div>
                            <div class="deals-table__cell deals-table__cell--ageing">
                                <span class="deals-table__lead-ageing">{{ deal.leadAgeing }}</span>
                            </div>
                            <div class="deals-table__cell deals-table__cell--product">
                                <span class="deals-table__product-name">{{ deal.product }}</span>
                            </div>
                            <div class="deals-table__cell deals-table__cell--revenue">
                                <span class="deals-table__revenue-amount">{{
                                    deal.potentialRevenue
                                }}</span>
                            </div>
                            <div class="deals-table__cell deals-table__cell--contacted">
                                <span class="deals-table__contact-date">{{
                                    deal.lastContacted === valueConstants.NA || !deal.lastContacted
                                        ? deal.lastContacted
                                        : (deal.lastContacted | date: 'dd-MMM-yyyy')
                                }}</span>
                            </div>
                        </div>
                    }
                } @else {
                    <div class="deals-table__empty">
                        <span class="deals-table__empty-text">No deals found</span>
                    </div>
                }
            </div>
        </div>
    }

    <!-- Error State -->
    @if (error() && !isLoading()) {
        <div class="deals-pipeline__error">
            <span class="deals-pipeline__error-text">{{ error() }}</span>
        </div>
    }
</div>
